import type { BoardData } from "@/lib/kanban";

const API_BASE = "";

export const fetchKanban = async (username = "user"): Promise<BoardData> => {
  const response = await fetch(`${API_BASE}/api/kanban?username=${encodeURIComponent(username)}`, {
    credentials: "same-origin",
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error("Failed to load board");
  }

  const data = await response.json();
  return data.board as BoardData;
};

export const saveKanban = async (board: BoardData, username = "user"): Promise<BoardData> => {
  const response = await fetch(`${API_BASE}/api/kanban`, {
    method: "PUT",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, board }),
  });

  if (!response.ok) {
    throw new Error("Failed to save board");
  }

  const data = await response.json();
  return data.board as BoardData;
};
